import React, { useEffect } from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Content from "../../Components/Core/Content";

const Unauthorized = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate("/");
  };

  useEffect(() => {
    document.title = "عدم دسترسی";
  }, []);

  return (
    <>
      {" "}
      <Content>
        <div className="text-center row mt-5">
          <div className="col">
            <h2 className="mb-4 iran-sans text-danger">
              شما دسترسی به این عملیات ندارید
            </h2>
            <Button variant="contained" color="primary" onClick={handleGoBack}>
              <span>بازگشت</span>
            </Button>
          </div>
        </div>
      </Content>
    </>
  );
};

export default Unauthorized;
